/* ==========================================================================
   FitsBy Shopify Theme Core JavaScript — Interactive Commerce Modules
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {
  initCartDrawer();
  initBundleBuilder();
  initFAQAccordions();
  initMobileMenu();
  initMegaMenu();
  initMegaMenuAccordion();
  initMobileCategoryAccordion();
  initProductCardSwatches();
  initSearchPopover();
  initAccountPopover();
  initCollectionFilters();
  initLinkPrefetching();
  initCookiePreferences();
});

/* --------------------------------------------------------------------------
   1. Cart Drawer Module Initializer
   -------------------------------------------------------------------------- */
// Managed by unified AJAX Cart Engine below (initCartDrawer)

/* --------------------------------------------------------------------------
   2. Tiered Bundle & Save Builder Module
   -------------------------------------------------------------------------- */
function initBundleBuilder() {
  const bundleContainer = document.getElementById('BundleBuilderContainer');
  if (!bundleContainer) return;

  const checkboxes = bundleContainer.querySelectorAll('.js-bundle-checkbox');
  const totalDisplay = bundleContainer.querySelector('.js-bundle-total-price');
  const savingsDisplay = bundleContainer.querySelector('.js-bundle-savings-amount');
  const discountBadge = bundleContainer.querySelector('.js-bundle-discount-badge');

  function calculateBundle() {
    let baseTotal = 0;
    let checkedCount = 0;

    checkboxes.forEach(cb => {
      if (cb.checked) {
        checkedCount++;
        baseTotal += parseFloat(cb.dataset.price || 0);
      }
    });

    let discountPercentage = 0;
    if (checkedCount >= 3) {
      discountPercentage = 0.15; // 15% OFF for 3+ items
    } else if (checkedCount === 2) {
      discountPercentage = 0.10; // 10% OFF for 2 items
    }

    const savingsAmount = baseTotal * discountPercentage;
    const finalTotal = baseTotal - savingsAmount;

    if (totalDisplay) {
      totalDisplay.textContent = '€' + finalTotal.toFixed(2);
    }
    if (savingsDisplay) {
      savingsDisplay.textContent = '€' + savingsAmount.toFixed(2);
    }
    if (discountBadge) {
      if (discountPercentage > 0) {
        discountBadge.textContent = (discountPercentage * 100) + '% SAVINGS APPLIED';
        discountBadge.style.display = 'inline-block';
      } else {
        discountBadge.style.display = 'none';
      }
    }
  }

  checkboxes.forEach(cb => {
    cb.addEventListener('change', calculateBundle);
  });

  calculateBundle();
}

/* --------------------------------------------------------------------------
   3. FAQ Accordion Module
   -------------------------------------------------------------------------- */
function initFAQAccordions() {
  const accordions = document.querySelectorAll('.js-faq-accordion');

  accordions.forEach(acc => {
    const trigger = acc.querySelector('.js-faq-trigger');
    const content = acc.querySelector('.js-faq-content');

    if (!trigger || !content) return;

    trigger.addEventListener('click', () => {
      const isOpen = acc.classList.contains('active');

      // Close sibling accordions
      const parent = acc.closest('.js-faq-group');
      if (parent) {
        parent.querySelectorAll('.js-faq-accordion').forEach(sibling => {
          sibling.classList.remove('active');
          const sibContent = sibling.querySelector('.js-faq-content');
          if (sibContent) sibContent.style.maxHeight = null;
        });
      }

      if (!isOpen) {
        acc.classList.add('active');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
}

/* --------------------------------------------------------------------------
   4. Mobile Menu Module
   -------------------------------------------------------------------------- */
function initMobileMenu() {
  const menuToggle = document.getElementById('MobileMenuToggle');
  const mobileNav = document.getElementById('MobileNavDrawer');
  const mobileOverlay = document.getElementById('MobileNavOverlay');
  const closeBtn = document.getElementById('MobileNavClose');

  if (!menuToggle || !mobileNav) return;

  function openMobileNav() {
    mobileNav.classList.add('active');
    if (mobileOverlay) mobileOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileNav() {
    mobileNav.classList.remove('active');
    if (mobileOverlay) mobileOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  menuToggle.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (mobileNav.classList.contains('active')) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      closeMobileNav();
    });
  }

  if (mobileOverlay) {
    mobileOverlay.addEventListener('click', closeMobileNav);
  }

  window.openMobileNav = openMobileNav;
  window.closeMobileNav = closeMobileNav;
}

/* --------------------------------------------------------------------------
   5. Desktop Mega Menu Module
   -------------------------------------------------------------------------- */
function initMegaMenu() {
  const categoryTriggers = document.querySelectorAll('.js-mega-menu-trigger');
  const megaPanel = document.getElementById('MegaMenuPanel');

  if (!megaPanel || !categoryTriggers.length) return;

  let timer;

  function showPanel() {
    clearTimeout(timer);
    megaPanel.classList.add('is-active');
  }

  function hidePanel() {
    timer = setTimeout(() => {
      if (!megaPanel.matches(':hover')) {
        let isHoveringTrigger = false;
        categoryTriggers.forEach(trig => {
          if (trig.matches(':hover')) isHoveringTrigger = true;
        });
        if (!isHoveringTrigger) {
          megaPanel.classList.remove('is-active');
          // Reset all accordion items to default closed state
          const accordionContainer = document.getElementById('MegaMenuAccordion');
          if (accordionContainer) {
            accordionContainer.querySelectorAll('.js-mega-accordion-item').forEach(it => {
              it.classList.remove('is-open');
              const t = it.querySelector('.js-mega-accordion-trigger');
              if (t) t.setAttribute('aria-expanded', 'false');
            });
          }
        }
      }
    }, 250);
  }

  categoryTriggers.forEach(trig => {
    trig.addEventListener('mouseenter', showPanel);
    trig.addEventListener('mouseleave', hidePanel);
  });

  megaPanel.addEventListener('mouseenter', showPanel);
  megaPanel.addEventListener('mouseleave', hidePanel);

  // Immediately close mega panel when moving cursor to standard dropdowns or regular nav links
  const nonMegaNavElements = document.querySelectorAll('.glass-nav-pill .nav-dropdown-wrapper:not(.has-mega-menu), .glass-nav-pill > a.nav-link');
  nonMegaNavElements.forEach(el => {
    el.addEventListener('mouseenter', () => {
      clearTimeout(timer);
      megaPanel.classList.remove('is-active');
      const accordionContainer = document.getElementById('MegaMenuAccordion');
      if (accordionContainer) {
        accordionContainer.querySelectorAll('.js-mega-accordion-item').forEach(it => {
          it.classList.remove('is-open');
          const t = it.querySelector('.js-mega-accordion-trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      }
    });
  });
}

/* --------------------------------------------------------------------------
   5b. Desktop Mega Menu 2nd Level Accordion Module
   -------------------------------------------------------------------------- */
function initMegaMenuAccordion() {
  const accordionContainer = document.getElementById('MegaMenuAccordion');
  if (!accordionContainer) return;

  const items = accordionContainer.querySelectorAll('.js-mega-accordion-item');
  if (!items.length) return;

  function closeItem(item) {
    if (!item) return;
    item.classList.remove('is-open');
    const trigger = item.querySelector('.js-mega-accordion-trigger');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function openItem(item) {
    if (!item) return;
    items.forEach(otherItem => {
      if (otherItem !== item) closeItem(otherItem);
    });
    item.classList.add('is-open');
    const trigger = item.querySelector('.js-mega-accordion-trigger');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function closeAll() {
    items.forEach(closeItem);
  }

  // Ensure default state on load is closed for all accordion items
  closeAll();

  items.forEach(item => {
    const trigger = item.querySelector('.js-mega-accordion-trigger');
    if (!trigger) return;

    // Hover open & close
    item.addEventListener('mouseenter', () => {
      openItem(item);
    });

    item.addEventListener('mouseleave', () => {
      closeItem(item);
    });

    // Click toggle (for touch/click interactions)
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const isOpen = item.classList.contains('is-open');
      if (isOpen) {
        closeItem(item);
      } else {
        openItem(item);
      }
    });
  });

  // When cursor leaves the mega menu accordion or panel completely, ensure all items close
  accordionContainer.addEventListener('mouseleave', () => {
    closeAll();
  });

  const megaPanel = document.getElementById('MegaMenuPanel');
  if (megaPanel) {
    megaPanel.addEventListener('mouseleave', () => {
      closeAll();
    });
  }
}

/* --------------------------------------------------------------------------
   6. Mobile Category Accordion Module
   -------------------------------------------------------------------------- */
function initMobileCategoryAccordion() {
  const mobileNav = document.getElementById('MobileNavDrawer');
  if (!mobileNav) return;

  mobileNav.addEventListener('click', (e) => {
    // 1. Mobile top-level accordion trigger (e.g. Fitnessapparaten, Krachttraining)
    const trig = e.target.closest('.js-mobile-accordion-trigger');
    if (trig) {
      e.preventDefault();
      const parent = trig.closest('.js-mobile-accordion');
      if (parent) {
        parent.classList.toggle('active');
        const isNowActive = parent.classList.contains('active');
        trig.setAttribute('aria-expanded', isNowActive ? 'true' : 'false');
      }
      return;
    }

    // 2. Mobile 2nd-level subaccordion trigger (e.g. Loopbanden, Dumbbells)
    const strig = e.target.closest('.js-mobile-subaccordion-trigger');
    if (strig) {
      e.preventDefault();
      e.stopPropagation();
      const subParent = strig.closest('.js-mobile-subaccordion');
      if (!subParent) return;

      const isAlreadyActive = subParent.classList.contains('active');

      // Close sibling subaccordions in the same mobile group
      const container = subParent.parentElement;
      if (container) {
        container.querySelectorAll('.js-mobile-subaccordion').forEach(sibling => {
          if (sibling !== subParent) {
            sibling.classList.remove('active');
            const siblingTrig = sibling.querySelector('.js-mobile-subaccordion-trigger');
            if (siblingTrig) siblingTrig.setAttribute('aria-expanded', 'false');
          }
        });
      }

      if (isAlreadyActive) {
        subParent.classList.remove('active');
        strig.setAttribute('aria-expanded', 'false');
      } else {
        subParent.classList.add('active');
        strig.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    // 3. Mobile Localization trigger
    const locTrig = e.target.closest('.js-mobile-loc-trigger');
    if (locTrig) {
      e.preventDefault();
      e.stopPropagation();
      const locPanel = document.getElementById('MobileNavLocalizationList');
      if (locPanel) {
        const isHidden = locPanel.hasAttribute('hidden') || locPanel.hidden;
        if (isHidden) {
          locPanel.removeAttribute('hidden');
          locPanel.hidden = false;
          locTrig.setAttribute('aria-expanded', 'true');
        } else {
          locPanel.setAttribute('hidden', '');
          locPanel.hidden = true;
          locTrig.setAttribute('aria-expanded', 'false');
        }
      }
      return;
    }
  });

  // Close mobile localization dropdown on click outside
  document.addEventListener('click', (e) => {
    const locPanel = document.getElementById('MobileNavLocalizationList');
    const locTrig = document.querySelector('.js-mobile-loc-trigger');
    if (locPanel && locTrig && !locTrig.contains(e.target) && !locPanel.contains(e.target)) {
      locPanel.setAttribute('hidden', '');
      locPanel.hidden = true;
      locTrig.setAttribute('aria-expanded', 'false');
    }
  });
}

/* --------------------------------------------------------------------------
   7. Product Card Variant Swatches Selection Module
   -------------------------------------------------------------------------- */
function initProductCardSwatches() {
  document.addEventListener('click', (e) => {
    const swatch = e.target.closest('.swatch-chip');
    if (!swatch) return;

    const card = swatch.closest('.fitsby-product-card');
    if (!card) return;

    // 1. Toggle Active State visually on swatches inside this card
    const siblings = card.querySelectorAll('.swatch-chip');
    siblings.forEach(s => s.classList.remove('is-active'));
    swatch.classList.add('is-active');

    // 2. Update Variant ID on Quick Add button (for Shopify Cart API)
    const variantId = swatch.dataset.variantId;
    const quickAddBtn = card.querySelector('.card-quick-add-btn');
    if (quickAddBtn && variantId) {
      quickAddBtn.dataset.variantId = variantId;
    }

    // 3. Update Price display with smooth highlight animation
    const variantPrice = swatch.dataset.variantPrice;
    const activePriceEl = card.querySelector('.active-price');
    if (activePriceEl && variantPrice) {
      activePriceEl.textContent = variantPrice;
      activePriceEl.classList.remove('price-updated-flash');
      void activePriceEl.offsetWidth; // trigger reflow for animation restart
      activePriceEl.classList.add('price-updated-flash');
    }

    // 4. Update Compare-at Price display
    const variantComparePrice = swatch.dataset.variantComparePrice;
    const comparePriceEl = card.querySelector('.compare-price');
    if (comparePriceEl) {
      if (variantComparePrice && variantComparePrice !== '') {
        comparePriceEl.textContent = variantComparePrice;
        comparePriceEl.style.display = 'inline';
      } else {
        comparePriceEl.textContent = '';
        comparePriceEl.style.display = 'none';
      }
    }

    // 5. Update Featured Image if variant has a distinct image
    const variantImg = swatch.dataset.variantImage;
    const cardImg = card.querySelector('.card-featured-img');
    if (cardImg && variantImg && variantImg !== '') {
      cardImg.src = variantImg;
    }
  });
}

/* --------------------------------------------------------------------------
   8. AJAX Cart Drawer Engine with Multi-Tier Progress & Milestone Tracking
   -------------------------------------------------------------------------- */
function formatMoneyCents(cents, currencyCode) {
  try {
    return new Intl.NumberFormat('en-IE', {
      style: 'currency',
      currency: currencyCode || 'EUR',
      minimumFractionDigits: 2
    }).format(cents / 100);
  } catch (e) {
    return '€' + (cents / 100).toFixed(2);
  }
}

function renderCartDrawer(cart) {
  if (!cart) return;

  // 1. Update Header Cart Badges (Desktop & Mobile)
  const headerCountBadges = document.querySelectorAll('.cart-pill-count-badge, .mobile-cart-count-badge');
  headerCountBadges.forEach(badge => {
    badge.textContent = cart.item_count;
  });

  // 2. Update Multi-Tier Shipping & Rewards Progress Bar
  const banner = document.querySelector('.cart-shipping-banner');
  const shippingFill = document.querySelector('.shipping-progress-fill');
  const shippingText = document.querySelector('.shipping-progress-text');

  if (banner) {
    const t1 = parseFloat(banner.dataset.t1) || 50;
    const t1Text = banner.dataset.t1Text || (window.fitsbyTranslations && window.fitsbyTranslations.tier1Default) || "GRATIS Verzending";
    const t2 = parseFloat(banner.dataset.t2) || 100;
    const t2Text = banner.dataset.t2Text || (window.fitsbyTranslations && window.fitsbyTranslations.tier2Default) || "Gratis Gym Shaker";
    const t3 = parseFloat(banner.dataset.t3) || 150;
    const t3Text = banner.dataset.t3Text || (window.fitsbyTranslations && window.fitsbyTranslations.tier3Default) || "10% Extra Korting";

    const totalEuro = (cart.total_price || 0) / 100;
    const currency = cart.currency || 'EUR';

    // Calculate percentage fill relative to max threshold (t3)
    const pct = Math.min(100, Math.max(0, Math.round((totalEuro / t3) * 100)));
    if (shippingFill) {
      shippingFill.style.width = pct + '%';
    }

    // Toggle achieved state on milestones
    const step1 = banner.querySelector('.step-1');
    const step2 = banner.querySelector('.step-2');
    const step3 = banner.querySelector('.step-3');

    if (step1) step1.classList.toggle('is-achieved', totalEuro >= t1);
    if (step2) step2.classList.toggle('is-achieved', totalEuro >= t2);
    if (step3) step3.classList.toggle('is-achieved', totalEuro >= t3);

    // Dynamic Progress Message Banner
    if (shippingText) {
      if (totalEuro < t1) {
        const remCents = Math.round((t1 - totalEuro) * 100);
        const amountFormatted = formatMoneyCents(remCents, currency);
        const tpl = (window.fitsbyTranslations && window.fitsbyTranslations.addMoreTier1) || "🚚 Voeg nog {{ amount }} toe voor {{ reward }}!";
        shippingText.innerHTML = tpl
          .replace('{{ amount }}', `<strong class="highlight-text">${amountFormatted}</strong>`)
          .replace('{{ reward }}', `<strong class="highlight-text">${t1Text}</strong>`);
      } else if (totalEuro < t2) {
        const remCents = Math.round((t2 - totalEuro) * 100);
        const amountFormatted = formatMoneyCents(remCents, currency);
        const tpl = (window.fitsbyTranslations && window.fitsbyTranslations.addMoreTier2) || "🎁 Voeg nog {{ amount }} toe voor {{ reward }}!";
        shippingText.innerHTML = tpl
          .replace('{{ amount }}', `<strong class="highlight-text">${amountFormatted}</strong>`)
          .replace('{{ reward }}', `<strong class="highlight-text">${t2Text}</strong>`);
      } else if (totalEuro < t3) {
        const remCents = Math.round((t3 - totalEuro) * 100);
        const amountFormatted = formatMoneyCents(remCents, currency);
        const tpl = (window.fitsbyTranslations && window.fitsbyTranslations.addMoreTier3) || "🔥 Voeg nog {{ amount }} toe voor {{ reward }}!";
        shippingText.innerHTML = tpl
          .replace('{{ amount }}', `<strong class="highlight-text">${amountFormatted}</strong>`)
          .replace('{{ reward }}', `<strong class="highlight-text">${t3Text}</strong>`);
      } else {
        const tpl = (window.fitsbyTranslations && window.fitsbyTranslations.allUnlocked) || `🎉 <strong class="highlight-text">Gefeliciteerd!</strong> Je hebt alle beloningen & GRATIS verzending ontgrendeld!`;
        shippingText.innerHTML = tpl;
      }
    }
  }

  // 3. Render Cart Drawer Items Body
  const drawerBody = document.querySelector('.cart-drawer-body');
  if (drawerBody) {
    if (!cart.items || cart.items.length === 0) {
      const emptyMsg = (window.fitsbyTranslations && window.fitsbyTranslations.cartEmpty) || "Je winkelwagen is momenteel leeg.";
      const continueMsg = (window.fitsbyTranslations && window.fitsbyTranslations.continueShopping) || "VERDER WINKELEN";

      // Check if user has active items in Custom Bundle Builder
      let bundleNoticeHTML = '';
      try {
        const bundleKeys = Object.keys(sessionStorage).filter(k => k.startsWith('fitsby_custom_bundle_'));
        for (const bk of bundleKeys) {
          const bItems = JSON.parse(sessionStorage.getItem(bk) || '[]');
          if (bItems && bItems.length > 0) {
            bundleNoticeHTML = `
              <div class="cart-drawer-bundle-notice" style="margin-top: 24px; padding: 14px 16px; background: #161A1F; border: 1.5px solid rgba(212, 246, 49, 0.4); border-radius: 6px; text-align: left;">
                <p style="margin: 0 0 6px; font-size: 13px; font-weight: 800; color: #D4F631; font-family: var(--font-display, 'Archivo', sans-serif); letter-spacing: 0.3px;">
                  ⚡ Je hebt ${bItems.length} ${bItems.length === 1 ? 'item' : 'items'} in je Bundel samengesteld!
                </p>
                <p style="margin: 0 0 12px; font-size: 12px; color: #9CA3AF; line-height: 1.4;">
                  Klik hieronder om direct naar je samengestelde bundel te gaan en af te rekenen.
                </p>
                <button type="button" class="btn js-cart-drawer-bundle-go" style="width: 100%; padding: 10px 14px; background: #D4F631; color: #0E1013; font-weight: 900; font-size: 12.5px; border: none; border-radius: 4px; cursor: pointer; text-transform: uppercase; font-family: var(--font-display, 'Archivo', sans-serif); letter-spacing: 0.8px;">
                  Naar Bundel & Afrekenen →
                </button>
              </div>
            `;
            break;
          }
        }
      } catch (e) { }

      drawerBody.innerHTML = `
        <div style="text-align: center; padding: 40px 0; color: var(--text-muted, #9CA3AF);">
          <p style="font-size: 16px; margin-bottom: 12px;">${emptyMsg}</p>
          <a href="/collections/all" class="btn btn-secondary js-cart-drawer-close" style="display: inline-block; padding: 10px 20px; background: #0E1013; color: #FFF; text-decoration: none; border-radius: 4px; font-weight: 700;">${continueMsg}</a>
          ${bundleNoticeHTML}
        </div>
      `;
      const newCloseBtn = drawerBody.querySelector('.js-cart-drawer-close');
      if (newCloseBtn && window.closeCartDrawer) {
        newCloseBtn.addEventListener('click', (e) => {
          e.preventDefault();
          window.closeCartDrawer();
        });
      }
      const bundleGoBtn = drawerBody.querySelector('.js-cart-drawer-bundle-go');
      if (bundleGoBtn) {
        bundleGoBtn.addEventListener('click', (e) => {
          e.preventDefault();
          if (window.closeCartDrawer) window.closeCartDrawer();
          const bundleSection = document.querySelector('.section-custom-bundle-builder, [id^="shopify-section-"][id*="bundle"]');
          if (bundleSection) {
            bundleSection.scrollIntoView({ behavior: 'smooth' });
          }
        });
      }
    } else {
      let itemsHTML = '';
      const removeItemLabel = (window.fitsbyTranslations && window.fitsbyTranslations.removeItem) || "Verwijder item";
      cart.items.forEach((item, index) => {
        const itemImg = item.image ? `<img src="${item.image}" alt="${item.product_title}" width="140" height="140" style="width: 100%; height: 100%; object-fit: cover;">` : '';

        // 1. Variant Options rendering (filtering out Default Title)
        let variantMarkup = '';
        const validOptions = (item.options_with_values || []).filter(opt =>
          opt.value &&
          opt.value !== 'Default Title' &&
          opt.name !== 'Title'
        );

        if (validOptions.length > 0) {
          const optionsList = validOptions.map(opt =>
            `<span style="font-size: 11px; padding: 2px 6px; background: var(--bg-surface, #F3F4F6); border: 1px solid var(--border-subtle, #E5E7EB); border-radius: 4px; color: var(--text-secondary, #374151); font-weight: 600;">${opt.name}: ${opt.value}</span>`
          ).join(' ');
          variantMarkup = `<div class="cart-drawer-item-options" style="display: flex; flex-wrap: wrap; gap: 4px; margin: 4px 0 6px;">${optionsList}</div>`;
        } else if (item.variant_title && item.variant_title !== 'Default Title' && item.variant_title !== 'Title') {
          variantMarkup = `<p style="font-size: 12px; color: var(--text-muted, #6B7280); margin: 2px 0 6px; font-weight: 600;">${item.variant_title}</p>`;
        }

        // 2. Line Item Properties & Bundle Offer Badges rendering
        let propertiesMarkup = '';
        if (item.properties && Object.keys(item.properties).length > 0) {
          const propItems = [];
          for (const [key, val] of Object.entries(item.properties)) {
            if (!key.startsWith('_') && val) {
              const keyLower = key.toLowerCase();
              if (keyLower.includes('bundle') || keyLower.includes('offer') || keyLower.includes('deal')) {
                propItems.push(`
                  <div class="cart-drawer-bundle-badge-wrap" style="margin-top: 4px; margin-bottom: 4px;">
                    <span class="cart-drawer-bundle-badge" style="display: inline-flex; align-items: center; gap: 4px; font-size: 10.5px; font-family: var(--font-display, 'Archivo', sans-serif); font-weight: 800; background: var(--accent-athletic, #D4F631); color: #0E1013; padding: 3px 8px; border-radius: 4px; text-transform: uppercase; letter-spacing: 0.5px; box-shadow: 0 1px 4px rgba(212, 246, 49, 0.3);">
                      ${val}
                    </span>
                  </div>
                `);
              } else {
                propItems.push(`<span style="font-size: 11px; color: var(--text-muted, #6B7280); display: block; margin-top: 2px;">${key}: ${val}</span>`);
              }
            }
          }
          if (propItems.length > 0) {
            propertiesMarkup = `<div class="cart-drawer-item-properties" style="margin-top: 2px;">${propItems.join('')}</div>`;
          }
        }

        // 3. Discounts rendering
        let discountsMarkup = '';
        if (item.discounts && item.discounts.length > 0) {
          const discList = item.discounts.map(d => `<span style="font-size: 11px; color: #10B981; font-weight: 600; display: block;">🏷️ ${d.title} (-${formatMoneyCents(d.amount, cart.currency)})</span>`).join('');
          discountsMarkup = `<div class="cart-drawer-item-discounts" style="margin-top: 2px;">${discList}</div>`;
        }

        // 4. Line Price & Compare Price rendering
        let priceMarkup = '';
        if (item.original_line_price && item.original_line_price > item.final_line_price) {
          priceMarkup += `<span style="font-size: 12px; color: var(--text-muted, #9CA3AF); text-decoration: line-through; margin-right: 4px;">${formatMoneyCents(item.original_line_price, cart.currency)}</span>`;
        }
        priceMarkup += `<span style="font-family: var(--font-display); font-weight: 700; color: var(--text-primary, #0E1013); font-size: 14px;">${formatMoneyCents(item.final_line_price, cart.currency)}</span>`;

        itemsHTML += `
          <div class="cart-drawer-item" data-line-key="${item.key}" data-line-index="${index + 1}" style="display: flex; gap: 14px; padding: 16px 0; border-bottom: 1px solid var(--border-subtle, #E5E7EB); position: relative;">
            <button type="button" class="cart-drawer-remove-btn js-remove-item" data-key="${item.key}" aria-label="${removeItemLabel}" title="${removeItemLabel}">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 6h18"></path>
                <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
                <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
                <line x1="10" y1="11" x2="10" y2="17"></line>
                <line x1="14" y1="11" x2="14" y2="17"></line>
              </svg>
            </button>

            <div style="width: 70px; height: 70px; background-color: var(--bg-elevated, #F8F9FA); border-radius: var(--radius-sm, 4px); overflow: hidden; flex-shrink: 0;">
              ${itemImg}
            </div>
            <div style="flex: 1; padding-right: 28px;">
              <h4 style="font-family: var(--font-display); font-size: 15px; color: var(--text-primary, #0E1013); font-weight: 700; margin: 0 0 2px;">${item.product_title}</h4>
              ${variantMarkup}
              ${propertiesMarkup}
              ${discountsMarkup}
              
              <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 10px;">
                <div class="drawer-qty-controls" style="display: inline-flex; align-items: center; border: 1px solid var(--border-default, #D1D5DB); border-radius: 4px; overflow: hidden; background: #FFF;">
                  <button type="button" class="js-qty-btn qty-minus" data-key="${item.key}" data-qty="${item.quantity - 1}" style="width: 28px; height: 28px; background: none; border: none; font-weight: bold; cursor: pointer; color: #0E1013;">-</button>
                  <span style="padding: 0 8px; font-size: 13px; font-weight: 700; min-width: 24px; text-align: center; color: #0E1013;">${item.quantity}</span>
                  <button type="button" class="js-qty-btn qty-plus" data-key="${item.key}" data-qty="${item.quantity + 1}" style="width: 28px; height: 28px; background: none; border: none; font-weight: bold; cursor: pointer; color: #0E1013;">+</button>
                </div>
                <div style="display: flex; align-items: center; gap: 10px;">
                  ${priceMarkup}
                </div>
              </div>
            </div>
          </div>
        `;
      });
      drawerBody.innerHTML = itemsHTML;
    }
  }

  // 4. Update Footer Subtotal & Sync Discount
  const footerSubtotals = document.querySelectorAll('#CartDrawerSubtotal, .js-cart-drawer-subtotal');
  footerSubtotals.forEach(subtotalEl => {
    subtotalEl.textContent = formatMoneyCents(cart.total_price, cart.currency);
  });
  syncCheckoutDiscount();
}

function updateCartQuantity(key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: parseInt(quantity, 10) })
  })
    .then(res => res.json())
    .then(cart => {
      renderCartDrawer(cart);
    })
    .catch(err => console.error('Error updating cart quantity:', err));
}

function applyCartDiscount(triggerEl) {
  let activeInput = null;

  if (triggerEl) {
    const parentContainer = triggerEl.closest('.cart-footer-modal-card') || triggerEl.closest('.cart-footer-panel-content') || triggerEl.closest('.cart-drawer-footer');
    if (parentContainer) {
      activeInput = parentContainer.querySelector('.coupon-input, #CartDrawerDiscountInput');
    }
  }

  if (!activeInput) {
    const allInputs = document.querySelectorAll('.coupon-input, #CartDrawerDiscountInput');
    for (const inp of allInputs) {
      if (inp.value && inp.value.trim().length > 0) {
        activeInput = inp;
        break;
      }
    }
    if (!activeInput && allInputs.length > 0) activeInput = allInputs[0];
  }

  if (!activeInput) return;

  const code = activeInput.value.trim();
  const allFeedbacks = document.querySelectorAll('.coupon-feedback, #CartDrawerDiscountFeedback');

  if (!code) {
    allFeedbacks.forEach(fb => {
      fb.style.display = 'flex';
      fb.className = 'coupon-feedback error';
      fb.innerHTML = '<span>Please enter a discount code.</span>';
    });
    return;
  }

  allFeedbacks.forEach(fb => {
    fb.style.display = 'flex';
    fb.className = 'coupon-feedback';
    fb.innerHTML = '<span style="color: #6B7280;">Applying code...</span>';
  });

  sessionStorage.setItem('fitsby_cart_discount', code);

  // Hit native Shopify discount URL endpoint & AJAX cart update
  Promise.all([
    fetch(`/discount/${encodeURIComponent(code)}`),
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })
    }).catch(() => { })
  ])
    .then(() => fetch('/cart.js'))
    .then(res => res.json())
    .then(cart => {
      renderCartDrawer(cart);
      syncCheckoutDiscount(code);
    })
    .catch(err => {
      console.error('Discount apply error:', err);
      syncCheckoutDiscount(code);
    });
}

function removeCartDiscount() {
  sessionStorage.removeItem('fitsby_cart_discount');
  const allInputs = document.querySelectorAll('.coupon-input, #CartDrawerDiscountInput');
  const allFeedbacks = document.querySelectorAll('.coupon-feedback, #CartDrawerDiscountFeedback');

  allInputs.forEach(inp => { inp.value = ''; });
  allFeedbacks.forEach(fb => {
    fb.style.display = 'none';
    fb.innerHTML = '';
  });

  fetch('/discount/CLEAR')
    .then(() => fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: '' })
    }).catch(() => { }))
    .then(() => fetch('/cart.js'))
    .then(res => res.json())
    .then(cart => {
      renderCartDrawer(cart);
      syncCheckoutDiscount('');
    })
    .catch(() => {
      syncCheckoutDiscount('');
    });
}

function syncCheckoutDiscount(codeOverride) {
  const savedCode = (codeOverride !== undefined) ? codeOverride : (sessionStorage.getItem('fitsby_cart_discount') || '');
  const checkoutBtns = document.querySelectorAll('a[href*="/checkout"]');

  checkoutBtns.forEach(btn => {
    let rawUrl = btn.getAttribute('href') || '/checkout';
    let baseUrl = rawUrl.split('?')[0];
    if (savedCode) {
      btn.setAttribute('href', `${baseUrl}?discount=${encodeURIComponent(savedCode)}`);
    } else {
      btn.setAttribute('href', baseUrl);
    }
  });

  const allInputs = document.querySelectorAll('.coupon-input, #CartDrawerDiscountInput');
  const allFeedbacks = document.querySelectorAll('.coupon-feedback, #CartDrawerDiscountFeedback');

  if (savedCode) {
    allInputs.forEach(inp => { inp.value = savedCode; });
    allFeedbacks.forEach(fb => {
      fb.style.display = 'flex';
      fb.className = 'coupon-feedback success';
      const cleanCode = savedCode.replace(/</g, "&lt;").replace(/>/g, "&gt;");
      fb.innerHTML = `<span>✓ Coupon "<strong>${cleanCode}</strong>" active!</span> <button type="button" class="coupon-remove-link js-remove-discount">Remove</button>`;
    });
  }
}

function openCartDrawer() {
  if (window.closeMobileNav) {
    window.closeMobileNav();
  }
  const overlay = document.getElementById('CartDrawerOverlay');
  if (overlay) {
    overlay.classList.add('active');
    overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    syncCheckoutDiscount();
  }
}

function closeCartDrawer() {
  const overlay = document.getElementById('CartDrawerOverlay');
  if (overlay) {
    overlay.classList.remove('active');
    overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }
}

function initCartDrawer() {
  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;
  window.renderCartDrawer = renderCartDrawer;
  window.syncCheckoutDiscount = syncCheckoutDiscount;

  // Keydown listener for Coupon input
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && e.target && (e.target.id === 'CartDrawerDiscountInput' || e.target.classList.contains('coupon-input'))) {
      e.preventDefault();
      applyCartDiscount(e.target);
    }
  });

  // Single Global Click Delegation for Cart Interactions
  document.addEventListener('click', (e) => {
    // 1. Open drawer triggers (header cart icon, etc.)
    const openTrigger = e.target.closest('.js-cart-drawer-trigger, .cart-pill-btn, .mobile-cart-btn, .mobile-quick-btn');
    const drawerOpenBtn = e.target.closest('.js-cart-drawer-open');
    if (openTrigger || (drawerOpenBtn && !drawerOpenBtn.classList.contains('card-quick-add-btn') && !drawerOpenBtn.closest('form[action*="/cart/add"]'))) {
      e.preventDefault();
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          renderCartDrawer(cart);
          openCartDrawer();
        });
      return;
    }

    // 2. Close trigger
    if (e.target.closest('.js-cart-drawer-close')) {
      e.preventDefault();
      closeCartDrawer();
      return;
    }

    // 3. Cart Footer Tabs (Coupon, Shipping, Guarantee) — Toggles Inline Window & Modal Popup
    const tabBtn = e.target.closest('.js-cart-footer-tab');
    if (tabBtn) {
      e.preventDefault();
      e.stopPropagation();
      const targetTab = tabBtn.getAttribute('data-tab');
      const container = tabBtn.closest('.cart-footer-quick-actions') || document;
      const allTabs = container.querySelectorAll('.js-cart-footer-tab');
      const allPanels = container.querySelectorAll('.cart-footer-panel-content');
      const targetPanel = container.querySelector(`#CartFooterPanel-${targetTab}`);

      const isAlreadyActive = tabBtn.classList.contains('is-active');

      allTabs.forEach(btn => {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-expanded', 'false');
      });

      allPanels.forEach(p => {
        p.classList.remove('is-active');
      });

      if (!isAlreadyActive && targetPanel) {
        tabBtn.classList.add('is-active');
        tabBtn.setAttribute('aria-expanded', 'true');
        targetPanel.classList.add('is-active');
        if (targetTab === 'coupon') {
          const input = targetPanel.querySelector('#CartDrawerDiscountInput');
          if (input) setTimeout(() => input.focus(), 150);
        }
      }

      // Also trigger Modal Window Popup overlay if available
      const modalOverlay = document.getElementById('CartFooterModalOverlay');
      const modalTitle = document.getElementById('CartFooterModalTitle');
      const modalBody = document.getElementById('CartFooterModalBody');

      if (modalOverlay && modalTitle && modalBody && !isAlreadyActive && targetPanel) {
        let titleText = 'Information';
        if (targetTab === 'coupon') titleText = '🏷️ Apply Promo / Discount Code';
        if (targetTab === 'shipping') titleText = '🚚 Shipping & Delivery Policy';
        if (targetTab === 'trust') titleText = '🛡️ Guarantee & Trust Policy';

        modalTitle.textContent = titleText;
        const innerContent = targetPanel.querySelector('.cart-footer-panel-inner');
        if (innerContent) {
          modalBody.innerHTML = innerContent.innerHTML;
        }
        modalOverlay.hidden = false;
        modalOverlay.classList.add('is-active');
      }
      return;
    }

    // 4. Cart Footer Modal Close Trigger
    if (e.target.closest('.js-cart-footer-modal-close') || (e.target.classList && e.target.classList.contains('cart-footer-modal-overlay'))) {
      const modalOverlay = document.getElementById('CartFooterModalOverlay');
      if (modalOverlay) {
        modalOverlay.classList.remove('is-active');
        setTimeout(() => { modalOverlay.hidden = true; }, 300);
      }
      return;
    }

    // 5. Apply Coupon Discount Button
    const applyDiscountBtn = e.target.closest('#CartDrawerDiscountApplyBtn, .coupon-submit-btn');
    if (applyDiscountBtn) {
      e.preventDefault();
      applyCartDiscount(applyDiscountBtn);
      return;
    }

    // 6. Remove Coupon Discount Link
    const removeDiscountBtn = e.target.closest('.js-remove-discount');
    if (removeDiscountBtn) {
      e.preventDefault();
      removeCartDiscount();
      return;
    }

    // 6. Quick Add to Cart Buttons
    const addBtn = e.target.closest('.card-quick-add-btn, .js-add-to-cart');
    if (addBtn) {
      e.preventDefault();

      let variantId = null;
      const card = addBtn.closest('.fitsby-product-card');

      // Prioritize currently active swatch variant on the card
      if (card) {
        const activeSwatch = card.querySelector('.swatch-chip.is-active');
        if (activeSwatch && activeSwatch.dataset.variantId) {
          variantId = activeSwatch.dataset.variantId;
        }
      }

      // Fallback to dataset on button itself
      if (!variantId) {
        variantId = addBtn.dataset.variantId;
      }

      // Fallback to first available swatch on card if active wasn't set
      if (!variantId && card) {
        const firstSwatch = card.querySelector('.swatch-chip[data-variant-id]');
        if (firstSwatch) {
          variantId = firstSwatch.dataset.variantId;
        }
      }

      if (!variantId) {
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            renderCartDrawer(cart);
            openCartDrawer();
          });
        return;
      }

      const originalText = addBtn.innerHTML;
      addBtn.classList.add('is-loading');
      addBtn.innerHTML = '<svg class="btn-spinner-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--accent-athletic, #D4F631)" stroke-width="3" stroke-linecap="round"><circle cx="12" cy="12" r="10" stroke="rgba(255,255,255,0.2)" stroke-width="3"/><path d="M12 2a10 10 0 0 1 10 10"/></svg>';
      addBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(res => {
          if (!res.ok) throw new Error('Failed to add item to cart');
          return res.json();
        })
        .then(() => fetch('/cart.js'))
        .then(res => res.json())
        .then(cart => {
          addBtn.classList.remove('is-loading');
          addBtn.classList.add('is-success');
          addBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0E1013" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg><span class="add-label" style="font-size: 11px; font-weight: 800; color: #0E1013;">ADDED</span>';
          renderCartDrawer(cart);
          openCartDrawer();
        })
        .catch(err => {
          console.error('Error adding product to cart:', err);
        })
        .finally(() => {
          setTimeout(() => {
            addBtn.classList.remove('is-loading');
            addBtn.classList.remove('is-success');
            addBtn.innerHTML = originalText;
            addBtn.disabled = false;
          }, 700);
        });
      return;
    }

    // 4. Quantity buttons inside drawer
    const qtyBtn = e.target.closest('.js-qty-btn');
    if (qtyBtn) {
      e.preventDefault();
      const key = qtyBtn.dataset.key;
      const qty = qtyBtn.dataset.qty;
      if (key && qty !== undefined) {
        updateCartQuantity(key, qty);
      }
      return;
    }

    // 5. Remove item button inside drawer
    const removeBtn = e.target.closest('.js-remove-item');
    if (removeBtn) {
      e.preventDefault();
      const key = removeBtn.dataset.key;
      if (key) {
        updateCartQuantity(key, 0);
      }
      return;
    }
  });

  // Intercept standard product forms submitting to /cart/add that do not have custom AJAX handlers
  document.addEventListener('submit', (e) => {
    if (e.defaultPrevented) return;
    const form = e.target.closest('form[action*="/cart/add"]');
    if (
      !form ||
      form.id === 'PdpAddToCartForm' ||
      form.classList.contains('js-banner-add-to-cart-form') ||
      form.classList.contains('js-accessory-add-form') ||
      form.classList.contains('js-related-add-form') ||
      form.hasAttribute('data-custom-ajax')
    ) return;

    e.preventDefault();
    const submitBtn = form.querySelector('[type="submit"], [name="add"]');
    const originalText = submitBtn ? submitBtn.innerHTML : '';
    if (submitBtn) {
      submitBtn.innerHTML = 'ADDING...';
      submitBtn.disabled = true;
    }

    const formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then(res => res.json())
      .then(() => fetch('/cart.js'))
      .then(res => res.json())
      .then(cart => {
        renderCartDrawer(cart);
        openCartDrawer();
      })
      .catch(err => console.error('Error submitting add to cart form:', err))
      .finally(() => {
        if (submitBtn) {
          submitBtn.innerHTML = originalText;
          submitBtn.disabled = false;
        }
      });
  });

  // Close when clicking overlay background
  const overlay = document.getElementById('CartDrawerOverlay');
  if (overlay) {
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        closeCartDrawer();
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initCartDrawer();
  initSearchPopover();
  initAccountPopover();
});

/* --------------------------------------------------------------------------
   8. Search Popover & Live Predictive Search Module
   -------------------------------------------------------------------------- */
function initSearchPopover() {
  const modal = document.getElementById('SearchPopoverModal');
  if (!modal) return;

  const openBtns = document.querySelectorAll('.js-search-open');
  const closeBtns = modal.querySelectorAll('.js-search-close');
  const input = document.getElementById('SearchPopoverInput');
  const clearBtn = document.getElementById('SearchPopoverClear');
  const resultsContainer = document.getElementById('SearchPopoverResults');
  const resultsContent = document.getElementById('SearchResultsContent');
  const spinner = document.getElementById('SearchLoadingSpinner');
  const quickTerms = document.getElementById('SearchQuickTerms');
  const quickTermBtns = modal.querySelectorAll('.js-quick-term-click');

  let debounceTimer = null;

  function openSearchModal() {
    if (window.closeMobileNav) {
      window.closeMobileNav();
    }
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('search-open-lock');
    if (input) {
      setTimeout(() => input.focus(), 150);
    }
  }

  function closeSearchModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('search-open-lock');
  }

  openBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openSearchModal();
    });
  });

  closeBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      closeSearchModal();
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeSearchModal();
    }
  });

  if (clearBtn && input) {
    clearBtn.addEventListener('click', () => {
      input.value = '';
      clearBtn.style.display = 'none';
      if (resultsContainer) resultsContainer.style.display = 'none';
      if (quickTerms) quickTerms.style.display = 'flex';
      input.focus();
    });
  }

  if (input) {
    input.addEventListener('input', (e) => {
      const query = e.target.value.trim();

      if (clearBtn) {
        clearBtn.style.display = query.length > 0 ? 'flex' : 'none';
      }

      if (query.length === 0) {
        if (resultsContainer) resultsContainer.style.display = 'none';
        if (quickTerms) quickTerms.style.display = 'flex';
        return;
      }

      if (quickTerms) quickTerms.style.display = 'none';
      if (resultsContainer) resultsContainer.style.display = 'block';
      if (spinner) spinner.style.display = 'flex';
      if (resultsContent) resultsContent.innerHTML = '';

      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        fetchPredictiveSearch(query);
      }, 300);
    });
  }

  quickTermBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const term = btn.dataset.term;
      if (term && input) {
        input.value = term;
        input.dispatchEvent(new Event('input'));
      }
    });
  });

  // Attach AJAX Add-To-Cart listener to Search Results Container once
  if (resultsContent && !resultsContent.dataset.searchCartListener) {
    resultsContent.dataset.searchCartListener = 'true';
    resultsContent.addEventListener('click', async (e) => {
      const addBtn = e.target.closest('.js-search-add-to-cart');
      if (!addBtn) return;

      e.preventDefault();
      e.stopPropagation();

      let variantId = addBtn.dataset.variantId;
      const handle = addBtn.dataset.handle;

      const originalText = addBtn.innerHTML;
      addBtn.classList.add('is-loading');
      addBtn.disabled = true;
      addBtn.innerHTML = `
        <svg class="search-btn-spinner" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0E1013" stroke-width="3" stroke-linecap="round">
          <circle cx="12" cy="12" r="10" stroke="rgba(0,0,0,0.2)" stroke-width="3"/>
          <path d="M12 2a10 10 0 0 1 10 10"/>
        </svg>
        <span>ADDING...</span>
      `;

      try {
        // If variantId is missing, empty, or unverified, fetch Product JSON via handle
        if (!variantId || variantId === 'undefined' || variantId === 'null' || variantId === '') {
          if (handle) {
            const res = await fetch(`/products/${handle}.js`);
            const prodData = await res.json();
            if (prodData && prodData.variants && prodData.variants.length > 0) {
              const firstAvailable = prodData.variants.find(v => v.available) || prodData.variants[0];
              variantId = firstAvailable.id;
              addBtn.dataset.variantId = variantId;
            }
          }
        }

        if (!variantId) {
          throw new Error('No valid variant ID found for search product.');
        }

        // POST to Shopify Cart API
        const cartAddRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        });

        if (!cartAddRes.ok) {
          const errJson = await cartAddRes.json();
          throw new Error(errJson.description || 'Failed to add item to cart');
        }

        // Fetch updated cart
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();

        addBtn.classList.remove('is-loading');
        addBtn.classList.add('is-success');
        addBtn.style.background = '#22C55E';
        addBtn.style.color = '#FFFFFF';
        addBtn.innerHTML = `
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
          <span>ADDED!</span>
        `;

        if (typeof window.renderCartDrawer === 'function') {
          window.renderCartDrawer(cart);
        }
        if (typeof window.openCartDrawer === 'function') {
          window.openCartDrawer();
        }

        setTimeout(() => {
          addBtn.classList.remove('is-success');
          addBtn.style.background = '';
          addBtn.style.color = '';
          addBtn.innerHTML = originalText;
          addBtn.disabled = false;
        }, 1500);

      } catch (err) {
        console.error('Error adding product to cart from search:', err);
        addBtn.classList.remove('is-loading');
        addBtn.innerHTML = `<span>FAILED</span>`;
        setTimeout(() => {
          addBtn.innerHTML = originalText;
          addBtn.disabled = false;
        }, 1500);
      }
    });
  }

  function fetchPredictiveSearch(query) {
    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`)
      .then(res => res.json())
      .then(data => {
        if (spinner) spinner.style.display = 'none';

        const products = data.resources?.results?.products || [];
        if (products.length === 0) {
          if (resultsContent) {
            resultsContent.innerHTML = `
              <div class="search-results-empty">
                <p>No products found for "<strong>${escapeHTML(query)}</strong>"</p>
              </div>
            `;
          }
          return;
        }

        let html = `
          <span class="search-results-header">Suggested Products (${products.length})</span>
          <div class="search-results-grid">
        `;

        products.forEach(prod => {
          const imgUrl = prod.image || prod.featured_image?.url || 'https://images.unsplash.com/photo-1517838277536-f5f99be501cd?q=80&w=200&auto=format&fit=crop';
          let priceStr = '';
          let comparePriceStr = '';

          if (prod.price) {
            priceStr = typeof prod.price === 'number' ? ('€' + (prod.price / 100).toFixed(2)) : ('€' + parseFloat(prod.price).toFixed(2));
          }

          if (prod.compare_at_price_min && parseFloat(prod.compare_at_price_min) > 0) {
            comparePriceStr = typeof prod.compare_at_price_min === 'number'
              ? ('€' + (prod.compare_at_price_min / 100).toFixed(2))
              : ('€' + parseFloat(prod.compare_at_price_min).toFixed(2));
          }

          // Only use variant ID if prod.variants is explicitly an array with valid items
          const variantId = (prod.variants && prod.variants.length > 0 && prod.variants[0].id)
            ? prod.variants[0].id
            : '';

          html += `
            <div class="search-result-card">
              <a href="${prod.url}" class="search-result-img-link" tabindex="-1">
                <img src="${imgUrl}" alt="${escapeHTML(prod.title)}" class="search-result-img" loading="lazy" width="84" height="84">
              </a>
              <div class="search-result-info">
                <a href="${prod.url}" class="search-result-title">${escapeHTML(prod.title)}</a>
                <div class="search-result-price-wrapper">
                  ${priceStr ? `<span class="search-result-price">${priceStr}</span>` : ''}
                  ${comparePriceStr ? `<span class="search-result-compare-price">${comparePriceStr}</span>` : ''}
                </div>
                <button type="button" 
                        class="search-card-add-btn js-search-add-to-cart" 
                        data-variant-id="${variantId}" 
                        data-handle="${prod.handle || ''}">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="9" cy="21" r="1"/>
                    <circle cx="20" cy="21" r="1"/>
                    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
                  </svg>
                  <span>ADD TO CART</span>
                </button>
              </div>
            </div>
          `;
        });

        html += `</div>`;
        html += `
          <a href="/search?q=${encodeURIComponent(query)}&type=product" class="search-results-view-all">
            VIEW ALL RESULTS FOR "${escapeHTML(query)}" →
          </a>
        `;

        if (resultsContent) {
          resultsContent.innerHTML = html;

          // Asynchronously pre-populate Variant IDs for search items
          const searchAddBtns = resultsContent.querySelectorAll('.js-search-add-to-cart[data-handle]');
          searchAddBtns.forEach(async (btn) => {
            if (!btn.dataset.variantId && btn.dataset.handle) {
              try {
                const pRes = await fetch(`/products/${btn.dataset.handle}.js`);
                const pData = await pRes.json();
                if (pData && pData.variants && pData.variants.length > 0) {
                  const firstAvail = pData.variants.find(v => v.available) || pData.variants[0];
                  btn.dataset.variantId = firstAvail.id;
                  if (!firstAvail.available) {
                    btn.disabled = true;
                    btn.querySelector('span').textContent = 'SOLD OUT';
                  }
                }
              } catch (e) {
                // Ignore background pre-fetch error
              }
            }
          });
        }
      })
      .catch(err => {
        console.error('Error fetching search results:', err);
        if (spinner) spinner.style.display = 'none';
        if (resultsContent) {
          resultsContent.innerHTML = `<div class="search-results-empty">Unable to load search results. Please try again.</div>`;
        }
      });
  }

  function escapeHTML(str) {
    if (!str) return '';
    return str.replace(/[&<>'"]/g,
      tag => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[tag] || tag)
    );
  }
}

/* --------------------------------------------------------------------------
   9. Account Popover Module
   -------------------------------------------------------------------------- */
function initAccountPopover() {
  const modal = document.getElementById('AccountPopoverModal');
  if (!modal) return;

  const openBtns = document.querySelectorAll('.js-account-open');
  const closeBtns = modal.querySelectorAll('.js-account-close');
  const emailInput = document.getElementById('AccountPopoverEmail');

  function openAccountModal() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('account-open-lock');
    if (emailInput) {
      setTimeout(() => emailInput.focus(), 150);
    }
  }

  function closeAccountModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('account-open-lock');
  }

  openBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const mobileDrawer = document.getElementById('MobileNavDrawer');
      const mobileOverlay = document.getElementById('MobileNavOverlay');
      if (mobileDrawer && mobileDrawer.classList.contains('active')) {
        mobileDrawer.classList.remove('active');
        if (mobileOverlay) mobileOverlay.classList.remove('active');
      }
      openAccountModal();
    });
  });

  closeBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      closeAccountModal();
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeAccountModal();
    }
  });
}

/* --------------------------------------------------------------------------
   10. Collection Faceted Filters & Sorting Handler Module
   -------------------------------------------------------------------------- */
function initCollectionFilters() {
  const filterForm = document.getElementById('CollectionFiltersForm');
  if (!filterForm) return;

  // Auto-submit filter form on input / select changes
  const inputs = filterForm.querySelectorAll('.js-filter-input');
  inputs.forEach(input => {
    input.addEventListener('change', () => {
      filterForm.submit();
    });
  });

  const sortSelect = document.querySelector('.js-sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      filterForm.submit();
    });
  }
}

/* --------------------------------------------------------------------------
   11. Smooth Page Navigation & Link Prefetching
   -------------------------------------------------------------------------- */
function initLinkPrefetching() {
  const prefetchedUrls = new Set();

  function prefetchUrl(url) {
    if (!url || prefetchedUrls.has(url)) return;

    try {
      const parsed = new URL(url, window.location.origin);
      if (parsed.origin !== window.location.origin) return;
      if (parsed.pathname === window.location.pathname && parsed.search === window.location.search) return;
      if (parsed.pathname.startsWith('/cdn-cgi') || parsed.pathname.startsWith('/cart') || parsed.pathname.includes('/checkouts')) return;

      prefetchedUrls.add(parsed.href);

      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = parsed.href;
      link.as = 'document';
      document.head.appendChild(link);
    } catch (e) {
      // Invalid URL, safely ignore
    }
  }

  // Event delegation on mouseover and touchstart for all internal links
  document.addEventListener('mouseover', (e) => {
    const anchor = e.target.closest('a');
    if (anchor && anchor.href) {
      prefetchUrl(anchor.href);
    }
  }, { passive: true });

  document.addEventListener('touchstart', (e) => {
    const anchor = e.target.closest('a');
    if (anchor && anchor.href) {
      prefetchUrl(anchor.href);
    }
  }, { passive: true });
}

/* --------------------------------------------------------------------------
   12. Cookie Consent & Privacy Preferences Handler
   -------------------------------------------------------------------------- */
function initCookiePreferences() {
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.js-cookie-preferences-trigger, [href*="#cookies"]');
    if (!trigger) return;

    if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.showPreferences === 'function') {
      e.preventDefault();
      window.Shopify.customerPrivacy.showPreferences();
    }
  });
}



